var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slidebar',{attrs:{"autoClose":true,"large":_vm.large,"extraLarge":_vm.extraLarge},on:{"closeMe":_vm.closeSlidebar}},[_c('h4',[_vm._v("Bekkjaleit")]),_c('br'),_c('ClassSearch',{attrs:{"slidebar":true},on:{"changeClass":_vm.closeSlidebar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }